// extracted by mini-css-extract-plugin
export default {"contentLinks":"ContentLinks_contentLinks__6jKQW"};